/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M19.25 12.7617A6.505 6.505 0 0 1 17.5 13a6.5046 6.5046 0 0 1-1.8459-.2658.7592.7592 0 0 1-.1541.0158h-9a.75.75 0 0 1 0-1.5h6.5629c-.9799-.9157-1.6762-2.131-1.9428-3.5H6.5a.75.75 0 0 1 0-1.5h4.5047a6.4661 6.4661 0 0 1 1.1855-3.5H4c-.6904 0-1.25.5596-1.25 1.25v16c0 .6904.5596 1.25 1.25 1.25h14c.6904 0 1.25-.5596 1.25-1.25v-7.2383Zm1.5-.6313C22.6929 11.0065 24 8.9059 24 6.5c0-1.1367-.2918-2.2052-.8045-3.1348l-4.6652 4.6651L18 8.5607l-.5303-.5304-2-2a.75.75 0 0 1 1.0606-1.0606L18 6.4393l4.3106-4.3106C21.1216.821 19.4067 0 17.5 0c-1.4334 0-2.7585.464-3.8332 1.25H4C2.4812 1.25 1.25 2.4812 1.25 4v16c0 1.5188 1.2312 2.75 2.75 2.75h14c1.5188 0 2.75-1.2312 2.75-2.75v-7.8696ZM5.75 17a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75Z"
    clipRule="evenodd"
  />,
  'MenuApprovalsFilled'
);
